export default __webpack_public_path__ + "static/media/l-intro-img-2.1a4011fb.svg";